module.exports = __webpack_public_path__ + "static/img/17.afc37a67.jpg";